import { useEffect } from 'react';
import { DOM } from '@app/utils';

import {
  useUserIsLoggedIn,
  useInitiateUserLogin,
  useCustomer,
} from '@app/user';

/**
 * loggedIn cookie is shared from help app
 *   and it's needed in order to force login/logout customer form iron and/or help app
 */
const useAutoLoginFlow = () => {
  const isLoggedIn = useUserIsLoggedIn();
  const initiateUserLogin = useInitiateUserLogin();
  const customer = useCustomer();
  useEffect(() => {
    if (isLoggedIn) {
      DOM.forceSetCookie('loggedIn', customer?.uuid);
    } else if (!isLoggedIn && DOM.getCookie('loggedIn')) {
      initiateUserLogin('login', {}, '');
    }
  }, [isLoggedIn]); // eslint-disable-line react-hooks/exhaustive-deps
};

export default useAutoLoginFlow;
